var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAssetclassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 4.33366C5.33268 4.88594 4.88497 5.33366 4.33268 5.33366C3.7804 5.33366 3.33268 4.88594 3.33268 4.33366C3.33268 3.78137 3.7804 3.33366 4.33268 3.33366C4.88497 3.33366 5.33268 3.78137 5.33268 4.33366Z",
    fill: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 1.33366C0.666016 0.965469 0.964492 0.666992 1.33268 0.666992H7.99935C8.17616 0.666992 8.34573 0.73723 8.47075 0.862254L14.1988 6.59032C14.5713 6.96505 14.7804 7.47195 14.7804 8.00033C14.7804 8.5287 14.5713 9.0356 14.1988 9.41033L13.726 8.94032L14.1974 9.41173L9.41768 14.1915C9.41759 14.1916 9.41777 14.1914 9.41768 14.1915C9.23199 14.3773 9.01124 14.525 8.76856 14.6256C8.52576 14.7262 8.26551 14.778 8.00268 14.778C7.73985 14.778 7.4796 14.7262 7.2368 14.6256C6.99407 14.525 6.77354 14.3775 6.58782 14.1916C6.58778 14.1916 6.58787 14.1917 6.58782 14.1916L0.861552 8.472C0.73636 8.34696 0.666016 8.17727 0.666016 8.00033V1.33366ZM13.2532 8.47032C13.2534 8.47012 13.2536 8.46991 13.2538 8.46971C13.3776 8.34486 13.4471 8.17616 13.4471 8.00033C13.4471 7.82449 13.3776 7.65579 13.2538 7.53094C13.2536 7.53074 13.2534 7.53053 13.2532 7.53032L7.72321 2.00033H1.99935V7.72396L7.53048 13.2486L7.53102 13.2492C7.59293 13.3112 7.66646 13.3603 7.74739 13.3939C7.82832 13.4274 7.91507 13.4447 8.00268 13.4447C8.09029 13.4447 8.17705 13.4274 8.25798 13.3939C8.33891 13.3603 8.41243 13.3112 8.47435 13.2492L13.2532 8.47032Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAssetclassIcon);
export default __webpack_public_path__ + "static/media/menu-assetclass-icon.9d391d275b3315de3dc4897a16850208.svg";
export { ForwardRef as ReactComponent };